<template>
  <section>
    <h4 class="form-card-header">{{ this.customerType ? $t('registration.personal-info') : $t('registration.child-info') }}</h4>
<!--    <div class="d-flex mb-4" v-if="customerType === true">-->
<!--      <img src="/img/emongolia.svg" alt="Fill information using E-Mongolia" width="150" class="cursor-pointer mr-2" @click="getDanUrl()"/>-->
<!--      <div>-->
<!--        <p style="font-style: italic; font-size: 11px; line-height: normal; padding-top: 10px;">Бүртгэлийн мэдээллээ "e-mongolia"-с татах </p>-->
<!--      </div>-->
<!--    </div>-->
    <div ref="generalInfoForm" class="form-card-form">
      <div>
        <label for="pi_nationality">{{ $t('registration.nationality') }}:<span class="text-danger">*</span></label>
        <select v-model="v$.form.nationality.$model"
                name="nationality"
                id="pi_nationality"
                class="form-select form-select-lg" :disabled="danState">
          <option v-for="item in Nationality" :value="item.key" :key="item.key"> {{ __("000_const.nationaly." + item.value) }}</option>
        </select>
        <input v-if="danState" v-model="v$.form.nationality.$model"
               name="nationality"
               id="pi_nationality" style="display: none"/>
        <div v-show="v$.form.nationality.$errors.length !== 0">
          <div class="error-message" v-show="!v$.form.nationality.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>

      <div>
        <label v-if="form.nationality === '496' || form.nationality === null" for="pi_register_number">{{ $t('registration.register-number') }}:<span class="text-danger">*</span></label>
        <label v-else for="pi_register_number">{{ $t('registration.passport-number') }}:<span class="text-danger">*</span></label>
        <div class="d-flex">
          <div class="d-flex" v-if="form.nationality === '496' || form.nationality === null">
            <select v-model="form.firstLetter"
                    class="form-select w-auto mr-2" :disabled="this.danState">
              <option v-for="item in Alphabets" :key="item">{{ item }}</option>
            </select>
            <select v-model="form.secondLetter"
                    class="form-select w-auto mr-2" :disabled="this.danState">
              <option v-for="item in Alphabets" :key="item">{{ item }}</option>
            </select>
            <input type="number"
                   size="sm"
                   class="pi-input"
                   id="pi_register_number"
                   v-model="v$.form.number.$model"
                   @blur="v$.form.number.$touch()"
                   :class="v$.form.number.$errors.length ? 'border-red-400 focus:border-red-500 focus:ring-offset-red-500' : ''"
                   placeholder="********" :readonly="this.danState"/>
          </div>
          <input v-else
                 type="text"
                 size="sm"
                 class="pi-input"
                 id="pi_register_number"
                 v-model="v$.form.number.$model"
                 @blur="v$.form.number.$touch()"
                 :class="v$.form.number.$errors.length ? 'border-red-400 focus:border-red-500 focus:ring-offset-red-500' : ''"
                 placeholder="********"/>
          <input type="text"
                 class="d-none"
                 name="register_number"
                 v-model="registerNumber"/>
        </div>
        <div v-show="v$.form.number.$errors.length">
          <div class="error-message">{{ $t('helper.please-enter-proper-number') }}</div>
        </div>
      </div>

      <div>
        <label for="pi_lastname">{{ $t('registration.lastname') }}:<span class="text-danger">*</span></label>
        <input
          id="pi_lastname"
          name="lastname"
          size="sm"
          type="text"
          class="pi-input"
          :placeholder="$t('registration.lastname')"
          v-model="v$.form.lastname.$model"
          @change="$emit('lastname', v$.form.lastname.$model)"
          @blur="v$.form.lastname.$touch()" :readonly="this.danState"
        />
        <div class="error-message" v-show="v$.form.lastname.$errors.length">
          <div v-show="!v$.form.lastname.$errors.required">{{ $t('helper.name-regex') }}</div>
          <div v-show="!v$.form.lastname.$errors.max">{{ $t('helper.text-count', { slot: '45' }) }}</div>
        </div>
      </div>

      <div>
        <label for="pi_firstname">{{ $t('registration.firstname') }}:<span class="text-danger">*</span></label>
        <input
          id="pi_firstname"
          name="firstname"
          size="sm"
          type="text"
          class="pi-input"
          :placeholder="$t('registration.firstname')"
          v-model="v$.form.firstname.$model"
          @change="$emit('firstname', v$.form.firstname.$model)"
          @blur="v$.form.firstname.$touch()" :readonly="this.danState"
        />
        <div class="error-message" v-show="v$.form.firstname.$errors.length">
          <div v-show="!v$.form.firstname.$errors.required">{{ $t('helper.name-regex') }}</div>
          <div v-show="!v$.form.firstname.$errors.max">{{ $t('helper.text-count', { slot: '45' }) }}</div>
        </div>
      </div>

      <div>
        <label for="pi_birthday">{{ $t('registration.birthdate') }}:<span class="text-danger">*</span></label>
        <input
            v-if="this.danState"
            id="pi_birthdate"
            name="birthday"
            size="sm"
            type="text"
            class="pi-input"
            v-model="v$.form.birthdate.$model"
            readonly
        />
        <date-picker v-else
          @change="changeDate"
        />
        <input
          id="pi_birthdate"
          name="birthday"
          v-model="v$.form.birthdate.$model"
          style="display: none;"
        />
        <div class="error-message" v-show="v$.form.birthdate.$errors.length">
          <div v-show="!v$.form.birthdate.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>

      <div>
        <label for="pi_email">{{ $t('registration.email') }}:<span class="text-danger">*</span></label>
        <input
          id="pi_email"
          name="email"
          size="sm"
          type="email"
          class="pi-input"
          v-model="v$.form.email.$model"
          @blur="v$.form.email.$touch()"
          placeholder="you@example.com"
          readonly
        />
        <div class="error-message" v-show="v$.form.email.$errors.length">
          <div v-show="!v$.form.email.$errors.required">{{ $t('helper.please-fill') }}</div>
          <div v-show="!v$.form.email.$errors.email">{{ $t('helper.please-enter-proper-email') }}</div>
        </div>
      </div>

      <div>
        <label for="pi_gender">{{ $t('registration.gender') }}:<span class="text-danger">*</span></label>
        <div class="ic-input sm">
          <select id="pi_gender"
                  class="form-select form-select-lg mb-3"
                  name="sex"
                  aria-label="form-select-lg"
                  v-model="v$.form.gender.$model"
                  @blur="v$.form.gender.$touch()" :disabled="danState">
            <option v-for="item in genders" :value="item.id">{{ item.text }}</option>
          </select>
          <input v-if="danState" v-model="v$.form.gender.$model"
                 id="pi_gender"
                 name="sex" style="display: none"/>
          <div class="error-message" v-show="v$.form.gender.$errors.length">
            <div v-show="!v$.form.gender.$errors.required">{{ $t('helper.please-fill') }}</div>
          </div>
        </div>
      </div>
      <div>
        <label for="pi_civil_id">{{ $t('registration.civil_id') }}:<span class="text-danger">*</span></label>
        <input
            id="pi_civil_id"
            name="civil_id"
            size="sm"
            type="number"
            class="pi-input"
            placeholder="************"
            v-model="v$.form.civil_id.$model"
            @blur="v$.form.civil_id.$touch()" :readonly="this.danState"
        />
        <div class="error-message" v-show="v$.form.civil_id.$errors.length">
          <div v-show="!v$.form.civil_id.$errors.required">{{ $t('helper.please-fill') }}</div>
          <div v-show="!v$.form.civil_id.$errors.min || !v$.form.civil_id.$errors.max">{{ $t('helper.text-count', { slot: '12' }) }}</div>
        </div>
      </div>
      <div>
        <label for="pi_disability">{{ $t('registration.disability') }}:<span class="text-danger">*</span></label>
        <select id="pi_disability"
                v-model="v$.form.disability.$model"
                name="disability"
                class="form-select dropdown-color">
          <option v-for="item in yesOrNo" :key="item.id" :value="item.id">{{ item.label }}</option>
        </select>
        <div class="error-message" v-show="v$.form.disability.$errors.length">
          <div v-show="!v$.form.disability.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>
      <div>
        <label for="pi_phone_number">{{ $t('registration.phone-number') }}:<span class="text-danger">*</span></label>
        <input
          id="pi_phone_number"
          name="mobilenumber"
          size="sm"
          type="number"
          class="pi-input"
          placeholder="********"
          v-model="v$.form.phoneNumber.$model"
          @blur="v$.form.phoneNumber.$touch()"
        />
        <div class="error-message" v-show="v$.form.phoneNumber.$errors.length">
          <div v-show="!v$.form.phoneNumber.$errors.required">{{ $t('helper.please-fill') }}</div>
          <div v-show="!v$.form.phoneNumber.$errors.min">{{ $t('helper.min-text-count', { slot: '8' }) }}</div>
        </div>
      </div>

      <div v-if="form.disability === 1">
        <label for="pi_disability_type">{{ $t('registration.disability_type') }}:<span
            class="text-danger">*</span></label>
        <multiselect id="pi_disability_type" v-model="value"
                     placeholder="Та нэгээс дээш хариултыг сонгож болно" label="name" track-by="code" :options="options" :multiple="true"
                     :taggable="true" @tag="addTag" @input="onChange"></multiselect>
        <div class="error-message" v-show="v$.form.disability_type.$errors.length">
          <div v-show="!v$.form.disability_type.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
        <input type="hidden" name="disability_type" :value="form.disability_type" />
      </div>

      <div v-if="form.disability === 1">
        <label for="pi_disability_percent">{{ $t('registration.disability_percent') }}:<span class="text-danger">*</span></label>
        <input
            id="pi_disability_percent"
            name="disability_percent"
            size="sm"
            type="number"
            class="pi-input"
            placeholder="0%"
            v-model="v$.form.disability_percent.$model"
            @blur="v$.form.disability_percent.$touch()"
        />
        <div class="error-message" v-show="v$.form.disability_percent.$errors.length">
          <div v-show="!v$.form.disability_percent.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>
      <div v-if="form.disability === 1">
        <label for="pi_disability_start_date">{{ $t('registration.disability_start_date') }}:<span class="text-danger">*</span></label>
        <date-picker
            @change="changeStartDateDisability"
        />
        <input
            id="pi_disability_start_date"
            name="disability_start_date"
            v-model="v$.form.disability_start_date.$model"
            style="display: none;"
        />
        <div class="error-message" v-show="v$.form.disability_start_date.$errors.length">
          <div v-show="!v$.form.disability_start_date.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>
      <div v-if="form.disability === 1">
        <label for="pi_disability_end_date">{{ $t('registration.disability_end_date') }}:<span class="text-danger">*</span></label>
        <date-picker
                     @change="changeEndDateDisability"
        />
        <input
            id="pi_disability_end_date"
            name="disability_end_date"
            v-model="v$.form.disability_end_date.$model"
            style="display: none;"
        />
        <div class="error-message" v-show="v$.form.disability_end_date.$errors.length">
          <div v-show="!v$.form.disability_end_date.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>
      <input
        id="pi_dan_verified"
        name="dan_verified"
        v-model="form.dan_verified"
        style="display: none;"/>
      <section class="sub-step-buttons-container">
        <ic-button size="tn" type="button" color="grey" @click="previous()" class="d-flex align-items-center mr-3"><i class="sr sr-chevron-left"></i>{{ $t('button.previous') }}</ic-button>
        <ic-button size="tn" type="button" variant="success"  @click="next()" class="d-flex align-items-center ml-3">{{ $t('button.next') }} <i class="sr sr-chevron-right"></i></ic-button>
      </section>
    </div>
  </section>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {required, email, numeric, minLength, maxLength, requiredIf} from '@vuelidate/validators'
import { Alphabets } from '../../utils/constants'
import { Nationality } from "../../constants"
import DatePicker from '../DatePicker/index.vue'
import moment from 'moment/moment'
import danApi from '../../api/danApi'
import {mapState} from "vuex";
import { nameRegexValidator } from '../../mixins/regex'
import Multiselect from "vue-multiselect";

const format = /[ `!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?~]/
const chars = (value) => !(/\d/.test(value) || format.test(value))

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  props: {
    email: {
      type: String
    },
    customerType: {
      type: Boolean
    }
  },
  components: {
    DatePicker,
    Multiselect
  },
  data() {
    return {
      Nationality,
      Alphabets,
      form: {
        nationality: '496',
        firstLetter: null,
        secondLetter: null,
        number: null,
        lastname: null,
        firstname: null,
        birthdate: null,
        email: null,
        gender: null,
        phoneNumber: null,
        civil_id: null,
        dan_verified: 0,
        disability: 0,
        disability_percent: null,
        disability_type: null,
        disability_start_date: null,
        disability_end_date: null
      },
      yesOrNo: [{id: 1, label: 'тийм'}, {id: 0, label: 'үгүй'}],
      genders: [{
        id: 0,
        text: `${ this.$t('helper.male') }`,
        },
        {
          id: 1,
          text: `${ this.$t('helper.female') }`,
        },
        {
          id: 2,
          text: `${ this.$t('helper.others') }`,
        }
      ],
      value: [],
      options: [
        {name: "Харааны", code: 10},
        {name: "Ярианы", code: 20},
        {name: "Сонсголын", code: 30},
        {name: "Хөдөлгөөний", code: 40},
        {name: "Сэтгэцийн", code: 50},
        {name: "Бусад", code: 60}
      ]
    }
  },
  validations() {
    if(this.form.disability === 1) {
      return {
        form: {
          nationality: {required},
          // firstLetter: { required },
          // secondLetter: { required },
          number: {required, min: minLength(8)},
          lastname: {required, max: maxLength(45), nameRegexValidator},
          firstname: {required, max: maxLength(45), nameRegexValidator},
          birthdate: {required},
          email: {required, email},
          gender: {required},
          phoneNumber: {required, min: minLength(8), numeric},
          civil_id: {required, min: minLength(12), max: maxLength(12), numeric},
          disability: {required},
          disability_percent: {required },
          disability_type: { required },
          disability_start_date: { required },
          disability_end_date: { required },
        }
      }
    }

    return {
      form: {
        nationality: {required},
        // firstLetter: { required },
        // secondLetter: { required },
        number: {required, min: minLength(8)},
        lastname: {required, max: maxLength(45), nameRegexValidator},
        firstname: {required, max: maxLength(45), nameRegexValidator},
        birthdate: {required},
        email: {required, email},
        gender: {required},
        phoneNumber: {required, min: minLength(8), numeric},
        civil_id: {required, min: minLength(12), max: maxLength(12), numeric},
        disability: {required}
      }
    }
  },
  computed: {
    registerNumber() {
      if (this.form.firstLetter && this.form.secondLetter && this.form.number) {
        return (this.form.firstLetter + this.form.secondLetter + this.form.number.toString()).toLowerCase()
      } else if (this.form.nationality !== '496' && this.form.number !== null) {
        return this.form.number
      }
      return ''
    },
    ...mapState('user', ['danState', 'tempUser']),
  },
  mounted() {
    this.form.email = this.email
    this.form.nationality = '496'
    if(this.danState === true){
      this.$bvToast.toast(
          'Дангаар баталгаажуулалт амжилттай',
          {title: 'Амжилттай', variant: 'success'},
      )
      this.form.birthdate = moment(this.form.birthdate).format('YYYY-MM-DD').toString()
      this.v$.form.birthdate.$model = this.form.birthdate
      this.v$.form.birthdate.$touch()
      this.form.birthdate = this.tempUser.birthday
      this.form.lastname = this.tempUser.lastname
      this.form.firstname = this.tempUser.firstname
      this.form.civil_id = this.tempUser.civil_id
      this.form.gender = this.tempUser.sex
      this.form.firstLetter = this.tempUser.register_number.substring(0, 1).toUpperCase()
      this.form.secondLetter = this.tempUser.register_number.substring(1, 2).toUpperCase()
      this.form.number = this.tempUser.register_number.substring(2, 10)
      this.form.dan_verified = 1
      this.$emit('lastname', this.form.lastname)
      this.$emit('firstname', this.form.firstname)
    }
    else this.fillOldData()
  },
  methods: {
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },
    onChange(value) {
      const json = value.reduce((acc, item) => {
        acc[item.code] = item.name;
        return acc;
      }, {});
      this.form.disability_type = Object.keys(json).length !== 0 ? JSON.stringify(json) : null
    },
    changeDate(date) {
      this.form.birthdate = moment(date).format('YYYY-MM-DD').toString()
      this.v$.form.birthdate.$model = this.form.birthdate
      this.v$.form.birthdate.$touch()
    },

    changeStartDateDisability(date) {
      this.form.disability_start_date = moment(date).format('YYYY-MM-DD').toString()
      this.v$.form.disability_start_date.$model = this.form.disability_start_date
      this.v$.form.disability_start_date.$touch()
    },
    changeEndDateDisability(date) {
      this.form.disability_end_date = moment(date).format('YYYY-MM-DD').toString()
      this.v$.form.disability_end_date.$model = this.form.disability_end_date
      this.v$.form.disability_end_date.$touch()
    },
    previous() {
      this.$emit('previous')
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    async next() {
      await this.v$.$validate()
      if (!this.v$.$error) {
        this.$emit('next', this.form)
      } else {
        console.log(this.v$.$error)
        alert(`${ this.$('helper.please-fill-required-fields') }`)
      }
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    fillOldData() {
      if (!window.oldInputs) return;
      if (window.oldInputs['nationality']) {
        this.$set(this.form, 'nationality', window.oldInputs['nationality']);
      }
      if (window.oldInputs['firstname']) {
        this.$set(this.form, 'firstname', window.oldInputs['firstname']);
      }
      if (window.oldInputs['lastname']) {
        this.$set(this.form, 'lastname', window.oldInputs['lastname']);
      }
      if (window.oldInputs['register_number']) {
        this.$set(this.form, 'register_number', window.oldInputs['register_number']);
      }
      if (window.oldInputs['mobilenumber']) {
        this.$set(this.form, 'mobilenumber', window.oldInputs['mobilenumber']);
      }
      if (window.oldInputs['birthday']) {
        this.$set(this.form, 'birthday', window.oldInputs['birthday']);
      }
      if (window.oldInputs['city']) {
        this.$set(this.form, 'city', window.oldInputs['city']);
      }
      if (window.oldInputs['email']) {
        this.$set(this.form, 'email', window.oldInputs['email']);
      }
      if (window.oldInputs['sex']) {
        this.$set(this.form, 'sex', window.oldInputs['sex']);
      }
    }
  },
}
</script>